'use client';

import { createContext, type ReactNode, useContext } from 'react';
import { isEmbeddedModeEnforced } from 'app/clientConfig/embeddedMode';

const context = createContext<boolean>(false);

const { Provider } = context;

export function EmbeddedModeProvider({ children, isEnabled }: { children: ReactNode; isEnabled: boolean }) {
  return <Provider value={isEnabled}>{children}</Provider>;
}

export const useIsEmbeddedModeEnabled = (): boolean => {
  const isEnabled = useContext(context);

  // FIXME PWA-1316 Remove the Embedded Mode enforcement workaround
  return isEmbeddedModeEnforced() || isEnabled;
};
